import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  GRAY_COLOR_DISABLED,
  GRAY_COLOR_LIGHT,
  GRAY_COLOR_TEXT_DISABLED,
} from "../../../utils/colors";

// eslint-disable-next-line
export const CALLOUT_VARIANT = {
  NEUTRAL: "neutral",
};

const CALLOUT_PALETTES = {
  [CALLOUT_VARIANT.NEUTRAL]: {
    borderColor: GRAY_COLOR_LIGHT,
    backgroundColor: GRAY_COLOR_DISABLED,
    color: GRAY_COLOR_TEXT_DISABLED,
  },
};

const resolveCalloutPalette = (variant) => {
  switch (variant) {
    case CALLOUT_VARIANT.NEUTRAL:
      return CALLOUT_PALETTES[CALLOUT_VARIANT.NEUTRAL];
    default: {
      const exhaustiveCheck = variant;
      void exhaustiveCheck;
      return CALLOUT_PALETTES[CALLOUT_VARIANT.NEUTRAL];
    }
  }
};

const CalloutBox = ({
  children,
  variant = CALLOUT_VARIANT.NEUTRAL,
  borderColor,
  backgroundColor,
  color,
  role,
  sx = {},
}) => {
  const palette = resolveCalloutPalette(variant);

  return (
    <Box
      role={role}
      sx={{
        width: "100%",
        boxSizing: "border-box",
        border: `1px solid ${borderColor ?? palette.borderColor}`,
        backgroundColor: backgroundColor ?? palette.backgroundColor,
        color: color ?? palette.color,
        borderRadius: "12px",
        padding: "12px 16px",
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontSize: "13px",
          color: "inherit",
          lineHeight: 1.6,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export default CalloutBox;
